import React, { useEffect, useState } from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
} from "@chakra-ui/react";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchEmbassyMasterRequest,
  fetchRecommendedDoctorsRequest,
} from "../ipsStore/actions";
import PrimaryButton from "../../../components/PrimaryButton";
import FormSelector from "../../../components/FormSelector";

const SelectionModal = ({
  isOpen,
  onClose,
  healthConcern,
  hospital,
  handleSubmit = () => {},
  modalType,
}) => {
  const dispatch = useDispatch();
  const { recommendedDoctors, embassyMaster } = useSelector(
    (state) => state.ips
  );
  const [selectedOption, setSelectedOption] = useState(null);

  useEffect(() => {
    if (modalType === "doctor" && healthConcern && hospital) {
      let payload = {
        health_concern: healthConcern?.value,
        hospital: hospital,
      };
      dispatch(fetchRecommendedDoctorsRequest(payload));
    }
    if (modalType === "embassy") {
      dispatch(fetchEmbassyMasterRequest());
    }
  }, [dispatch, healthConcern, hospital, modalType]);

  useEffect(() => {
    if (!isOpen) {
      setSelectedOption(null);
    }
  }, [isOpen]);

  const handleSelection = () => {
    handleSubmit(selectedOption.value);
    onClose();
  };

  const getModalConfig = () => {
    if (modalType === "doctor") {
      return {
        title: "Recommended Doctors",
        label: "Doctors",
        placeholder: "Select Doctor",
        options: recommendedDoctors,
      };
    }
    return {
      title: "Embassy Selection",
      label: "Embassy",
      placeholder: "Select Embassy",
      options: embassyMaster,
    };
  };

  const config = getModalConfig();

  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader color="primary.1" textAlign={"center"} fontSize={"2xl"}>
          {config.title}
        </ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <FormSelector
            label={config.label}
            placeholder={config.placeholder}
            options={config.options}
            value={selectedOption}
            onChange={(selectedOption) => setSelectedOption(selectedOption)}
            closeMenuOnSelect={true}
            menuPortalTarget={false}
          />
        </ModalBody>
        <ModalFooter>
          <PrimaryButton
            colorScheme="blue"
            onClick={handleSelection}
            isDisabled={!selectedOption}
          >
            Select
          </PrimaryButton>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default SelectionModal;
